import Component from 'can/component/component';
import template from './win-probability-player.stache';
import { getFieldName } from 'components/probability/types';
import _ from 'lodash';
import dtm from 'scripts/services/dtm';

Component.extend({
    tag: 'win-probability-player',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            player: {
                type: 'object',
            },
            activeId: {
                type: 'string',
            },
            position: {
                type: 'object',
            },
            probability: {
                type: 'object',
            },
            probabilityType: {
                type: 'string',
            },
            round: {
                type: 'number',
            },

            currentProbability: {
                get() {
                    const probability = this.attr('probability');
                    if (!probability) {
                        return null;
                    }

                    const currentProbability =
                        probability[getFieldName(this.attr('probabilityType'))];

                    if (!currentProbability) {
                        return null;
                    }

                    return _.find(
                        currentProbability,
                        (it) => it.roundNumber === this.attr('round'),
                    );
                },
            },
        },
        setActiveId(player) {
            if (this.attr('activeId') === player.identifier) {
                return;
            }
            const probabilityType = this.attr('probabilityType');
            dtm.trackWinProbabilityPlayerClick(
                player.firstName + ' ' + player.lastName,
                probabilityType,
            );
            this.attr('activeId', player.identifier);
        },
        processDisplayValue(value) {
            return Number(value * 100).toFixed(1) + '%';
        },
    },
    events: {
        inserted() {},
    },
});
